(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.ageGate = {
        attach: function (context, settings) {
            const LANG_SELECTOR_KEY = 'language_selector_dismissed';
            const htmlElement = document.documentElement;

            once('age-gate', '.content.age-gate', context).forEach(function (ageGateElement) {
                const contentWrapper = ageGateElement.querySelector('.age-gate__content');

                const getLang = function () {
                    return (htmlElement.lang || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';
                };
                const getAgeGateKey = function () {
                    return 'age_gate_dismissed_' + getLang();
                };

                const showAgeGate = function () {
                    if (localStorage.getItem(getAgeGateKey()) === 'true') {
                        return;
                    }
                    setTimeout(function () {
                        ageGateElement.classList.add('age-gate--visible');
                    }, 500);
                };
                const hideAgeGate = function () {
                    localStorage.setItem(getAgeGateKey(), 'true');
                    ageGateElement.classList.remove('age-gate--visible');
                };

                const langSwitchLink = contentWrapper.querySelector('a[href*="/en"], a[href*="/fr"]');
                if (langSwitchLink) {
                    langSwitchLink.addEventListener('click', function () {
                        localStorage.removeItem('age_gate_dismissed_en');
                        localStorage.removeItem('age_gate_dismissed_fr');
                    });
                }

                const form = contentWrapper.querySelector('form');
                if (form) {
                    const provinceSelect = form.querySelector('select');
                    const dateInput = form.querySelector('input[type="date"]');
                    const submitButton = form.querySelector('input[type="submit"], button[type="submit"]');
                    if (dateInput) {
                        dateInput.disabled = true;
                    }
                    if (submitButton) {
                        submitButton.disabled = true;
                    }
                    function updateButtonState() {
                        if (provinceSelect && dateInput && submitButton) {
                            submitButton.disabled = !(provinceSelect.value && dateInput.value);
                        }
                    }
                    // Province legal age mapping (always use EN field names)
                    const provinceAges = {
                        'Alberta': 18,
                        'British Columbia': 19,
                        'Manitoba': 18,
                        'New Brunswick': 19,
                        'Newfoundland': 19,
                        'Northwest Territory': 19,
                        'Nova Scotia': 19,
                        'Nunavut': 19,
                        'Ontario': 18,
                        'Prince Edward Island': 18,
                        'Quebec': 18,
                        'Saskatchewan': 18,
                        'Yukon': 19
                    };

                    function setDateInputMax() {
                        if (!provinceSelect.value) {
                            dateInput.removeAttribute('max');
                            return;
                        }
                        const age = provinceAges[provinceSelect.value] || 18;
                        const today = new Date();
                        const maxYear = today.getFullYear() - age;
                        // Set max date to Dec 31 of the year
                        dateInput.max = maxYear + '-12-31';
                    }

                    if (provinceSelect && dateInput) {
                        provinceSelect.addEventListener('change', function () {
                            console.log('Selected region:', provinceSelect.value);
                            if (provinceSelect.value) {
                                dateInput.disabled = false;
                                setDateInputMax();
                            } else {
                                dateInput.disabled = true;
                                dateInput.value = '';
                                dateInput.removeAttribute('max');
                            }
                            updateButtonState();
                        });
                        dateInput.addEventListener('input', updateButtonState);
                    }
                    updateButtonState();
                    form.addEventListener('submit', function (e) {
                        sessionStorage.setItem(getAgeGateKey(), 'true');
                        hideAgeGate();
                    });
                }

                document.addEventListener('languageSelected', function () {
                    showAgeGate();
                });


                if (localStorage.getItem(LANG_SELECTOR_KEY) === 'true' && localStorage.getItem(getAgeGateKey()) !== 'true') {
                    setTimeout(function () {
                        ageGateElement.classList.add('age-gate--visible');
                    }, 1500);
                }
            });
        }
    };

})(Drupal, once);
